import { Box, IconButton, Stack, Typography } from '@mui/material';
import React, { memo } from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { LoanInventoryTableFields } from '../../types';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';
import { LoanInventoryTableFields as PortfolioLoanInventoryTableFields } from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/components/HbtPortfolioLoansInventoryTable/types';
import { LoanDetails } from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/components/HbtIndividualLoanDetails/types';

const HeaderHeader = ({
  data,
  toggleFlyout,
  isItMasterPoolLoans
}: {
  data: LoanInventoryTableFields[] | PortfolioLoanInventoryTableFields[] | LoanDetails[];
  toggleFlyout: (event: React.KeyboardEvent | React.MouseEvent) => void;
  isItMasterPoolLoans?: boolean;
}) => {
  const { t } = useTranslation('HbtMasterPool');
  return (
    <Box>
      <Stack
        className={`${styles.headerContainer} ${data.length === 1 ? styles.borderBottom : ''}`}
        direction="row"
        justifyContent="space-between"
      >
        <Box>
          <Typography className={styles.header}>
            {isItMasterPoolLoans ? t('Historical-Data') : t('Historical-Remarks')}
          </Typography>
          {data.length === 1 && isItMasterPoolLoans && (
            <Typography>
              {t('cmhc-account-number')}{' '}
              {'cmhcAccountNumber' in data[0] && data[0]?.cmhcAccountNumber}
            </Typography>
          )}
          {data.length === 1 && !isItMasterPoolLoans && (
            <Typography>
              {'cmhcAccountNumber' in data[0] && data[0]?.cmhcAccountNumber
                ? `${t('cmhc-account-number')} ${data[0]?.cmhcAccountNumber}`
                : `${t('lender-reference-number')} ${data[0]?.lenderReferenceNumber}`}
            </Typography>
          )}
        </Box>
        <Box>
          <IconButton
            sx={{ padding: 0 }}
            disableRipple
            aria-label="close flyout"
            onClick={toggleFlyout}
          >
            <CmhcIcon size={CmhcIconSize.LARGE} className={styles.icon} type="icon_close" />
          </IconButton>
        </Box>
      </Stack>
    </Box>
  );
};

export default memo(HeaderHeader);
